// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"03b65e91","187":"82c2a1b0","247":"87651a72","454":"9491f71f","457":"e3e2bdc8","825":"b7ad70f7"}[chunkId] + ".chunk.js";
};